import { Trans } from '@lingui/react'

import Notification from 'views/components/molecules/Notification'

export const MarketPlaceTotalAmountDiscount = ({
  discountConditionValue,
  discountValue,
  legalSufix,
}: {
  discountConditionValue: string
  discountValue: string
  legalSufix: number
}) => {
  const formattedTotalAmountDiscount = `${Number(discountValue).toFixed(0)}€`

  const totalAmountDiscountHeadline = (
    <Trans
      id="seller.promotion.sellerBanner.title.minimumSameItemQuantity.total"
      values={{
        sup: <sup>{legalSufix}</sup>,
      }}
    />
  )

  const totalAmountDiscountMessage = (
    <Trans
      id="seller.promotion.sellerBanner.message.minimumSameItemQuantity.totalAmount"
      values={{
        formattedConditionAmount: discountConditionValue,
        formattedDiscountAmount: formattedTotalAmountDiscount,
      }}
    />
  )

  return (
    <Notification
      alignIcon="top"
      className="u-background-color--background"
      dataQaId="marketplace-free-items-discount-modal"
      heading={totalAmountDiscountHeadline}
      label={
        <div
          className="u-margin-x-small--bottom"
          data-qa-id="marketplace-free-items-discount-modal-label"
        >
          {totalAmountDiscountMessage}
        </div>
      }
      type="infoPromotion"
    />
  )
}
